module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAYCAMAAAD08pwfAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAPFBMVEUAAAAlKS0lKS0lKS0lKS0lKS0lKS0lKS0lKS0lKS0lKS0lKS0lKS0lKS0lKS0lKS0lKS0lKS0lKS0lKS13DDbVAAAAE3RSTlMAbPxF8CfbEr0Glm1GKBOXmBQp8TP4YwAAAAFiS0dEAIgFHUgAAAAJcEhZcwAACxIAAAsSAdLdfvwAAABOSURBVBjTbc9JEoAgDERRRIzgAGrf/67ufqwyWb1FKp1OU2LyDFUWKFuhaoPanNqd+YAqJ5R1qNqghvMKFuzm2BNEePAInrT+L/Sp6eVfgSQIrGtSSOQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ../server/public/static/images/global/type-arrows/right-grey1@2x.png
// module id = 787
// module chunks = 0 1 2 3 4